import styled from "styled-components";
import { devices } from "../../Theme.css";
import { NavLink as Link } from "react-router-dom";

/** Mobile drawer: below sidebar (1220), above header + main content (~1010) */
export const SidebarBackdrop = styled.button`
  position: fixed;
  inset: 0;
  z-index: 1210;
  border: none;
  margin: 0;
  padding: 0;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: -2px;
  }
`;

type SidebarWrapperProps = {
  animation: "default" | "moveRight" | "moveLeft";
};

export const SidebarWrapper = styled.div<SidebarWrapperProps>`
  position: fixed;
  left: 0;
  top: calc(${({ theme }) => theme?.height?.header ?? "88px"} - 28px);
  right: auto;
  bottom: 0;
  width: ${({ theme }) => theme.width.sidebar};
  height: auto;
  background: #f9f9f9;
  box-shadow: 1px 1px 6px rgba(64, 26, 15, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 44px 15px 0; /* bottom padding handled by footer */
  z-index: ${({ theme }) => theme.zIndex.sidebar};
  transition: left 0.5s ease;

  .signout {
    display: none;
  }

  @media ${devices.max_sm} {
    /* Above backdrop (1210) and header (~1010) so drawer + nav stay reachable */
    z-index: 1220;

    .signout {
         display: flex;
        /* justify-content: center; */
        margin-left: 50px;
        margin-top: 50px;

        button {
          font-weight bold;
          color: red;
        }
        background-color:
    }

    left: -${({ theme }) => theme.width.sidebar};
    ${(props) =>
      props.animation === "moveRight"
        ? `left: 0`
        : props.animation === "moveLeft"
        ? `left: -${props.theme.width.sidebar}`
        : `left: -${({ theme }) => theme.width.sidebar};`}
  }
`;

export const SidebarContent = styled.div`
  flex: 1 1 auto;
  min-height: 0; /* ensures proper scrolling in flex column */
  overflow-y: auto;
  padding-bottom: 12px;
`;

export const SidebarFooter = styled.div`
  flex: 0 0 auto;
  padding: 12px 8px 1px;
  border-top: 1px solid rgba(0,0,0,0.06);
  background: #f9f9f9;
  position: relative;
  width: 100%;

  /* Normalize Policy footer inside the sidebar */
  & > div {
    position: static !important;
    width: 100% !important;
    margin: 0 !important;
    display: flex;
    justify-content: center;
  }

  & .link-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  & a {
    font-size: 12px !important;
  }
`;

export const NavLink = styled(Link)`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  height: 58px;
  border-radius: 100px;
  text-decoration: none;
  color: #000;
  background: transparent;
  padding: 12px 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  &:hover,
  &.active {
    color: #fff;
    background: #000;
    .icon {
      img {
        &.img-normal {
          display: none;
        }
        &.img-active {
          display: block;
        }
      }
    }
  }
  .icon {
    font-size: 26px;
    margin-right: 8px;
    img {
      width: 36px;
      &.img-normal {
        display: block;
      }
      &.img-active {
        display: none;
      }
    }
  }
  .txt {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    transition: none;
  }
`;

export const ButtonLink = styled.button`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  height: 58px;
  border-radius: 100px;
  text-decoration: none;
  color: #000;
  background: transparent;
  padding: 12px 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  &:hover,
  &.active {
    color: #fff;
    background: #000;
    .icon {
      img {
        &.img-normal {
          display: none;
        }
        &.img-active {
          display: block;
        }
      }
    }
  }
  .icon {
    font-size: 26px;
    margin-right: 8px;
    img {
      width: 36px;
      &.img-normal {
        display: block;
      }
      &.img-active {
        display: none;
      }
    }
  }
  .txt {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    transition: none;
  }
`;

export const TextBadge = styled.div`
  height: 19px;
  width: 19px;
  font-size: 13px;
  background: #ed3724;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  top: 7px;
  opacity: 0.95;
  color: white;
`;

export const TextNotification = styled.div`
  display: flex;
  align-items: center;
  .text {
    margin-left: 8px;
  }
`;

export const ProfileInformations = styled.div`
  display: none;
  width: 100%;

  p {
    margin-left: 12px;
    font-weight: bold;
    color: black;
  }

  @media ${devices.max_sm} {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
  }
`;
